import BRANDS from "./brands";

/**
 * Customer portal an organization is served.
 *
 * Values must match Types::Enums::CustomerPortalVersionEnumType on the backend.
 */
const CUSTOMER_PORTAL_VERSIONS = {
  missionDev: "MISSION_DEV",
  talentSimple: "TALENT_SIMPLE",
};

const CUSTOMER_PORTAL_VERSION_OPTIONS = [
  { value: CUSTOMER_PORTAL_VERSIONS.missionDev, labelId: "Organizations.CustomerPortalVersion.MissionDev" },
  { value: CUSTOMER_PORTAL_VERSIONS.talentSimple, labelId: "Organizations.CustomerPortalVersion.TalentSimple" },
];

const CUSTOMER_PORTAL_VERSION_BRANDS = {
  [CUSTOMER_PORTAL_VERSIONS.missionDev]: BRANDS.missionDev,
  [CUSTOMER_PORTAL_VERSIONS.talentSimple]: BRANDS.talentSimple,
};

const isTalentSimplePortal = (customerPortalVersion) => customerPortalVersion === CUSTOMER_PORTAL_VERSIONS.talentSimple;

const isMissionDevPortal = (customerPortalVersion) => customerPortalVersion === CUSTOMER_PORTAL_VERSIONS.missionDev;

export { CUSTOMER_PORTAL_VERSION_OPTIONS, CUSTOMER_PORTAL_VERSION_BRANDS, isTalentSimplePortal, isMissionDevPortal };

export default CUSTOMER_PORTAL_VERSIONS;
